import * as React from "react";
import i18n from "../../../i18n/i18n";
import {Popup} from "../../../common/components/shared/popup/popup";
import {ReactComponent as ResetPasswordIcon} from "../../../statics/icons/icon_reset.svg";
import "./resetPasswordPopup.scss";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {Api} from "../../../helpers/api";

interface ResetPasswordPopupProps {
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    username: string;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting: boolean;
}

export default function ResetPasswordPopup(props: ResetPasswordPopupProps): React.ReactElement {
    const content = <div>
        {i18n.t("administration.resetPasswordAction.firstPart")}
        <b>{props.username}</b>
        {i18n.t("administration.resetPasswordAction.lastPart")}
    </div>;

    return (
        <Popup
            open={props.displayPopup}
            className="reset-password-popup"
            header={i18n.t("administration.resetPasswordAction.header")}
            secondHeader={i18n.t("administration.resetPasswordAction.secondHeader")}
            icon={<ResetPasswordIcon/>}
            content={content}
            actionText={i18n.t("administration.resetPasswordAction.actionText")}
            action={props.confirm}
            cancel={props.closePopup}
            testId="reset-password-popup"
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={i18n.t("administration.errors.resetPasswordErrorSuffix")}
                            translatedFields={{
                                id: i18n.t("administration.errors.idNotFound")
                            }}
                        />
                    )}
                </>
            }
            isWaiting={props.isWaiting}
        />
    );
}
